var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_21f186f6"]},_vm.$listeners),[_c('cube-button-group',{class:["btn-wrapper"]},[_c('cube-button',{class:["btn-item"]},[_vm._v("取消按钮")]),_c('cube-button',{class:["btn-item"],attrs:{"primary":""}},[_vm._v("确认按钮")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }